import {SeriesSimpleVo} from '../../common/shared/api/nicolas/vo/SeriesSimpleVo.interface';
import {SaleState, SimpleSeriesSingleInfo} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createSaleState} from './SaleState';
import {createSlideType} from './SlideType.enum';

export function createSimpleSeriesSingleInfo({
  single_age_grade,
  age_grade,
  is_free,
  is_text_viewer,
  slide_type,
  series_sale_state,
  single_sale_state,
}: SeriesSimpleVo): SimpleSeriesSingleInfo {
  return {
    seriesAgeGrade: createAgeGrade(age_grade),
    singleAgeGrade:
      single_age_grade !== undefined
        ? createAgeGrade(single_age_grade)
        : undefined,
    singleIsFree: is_free,
    singleIsTextViewer: is_text_viewer,
    singleSlideType: createSlideType(slide_type),
    seriesSaleState: series_sale_state
      ? createSaleState(series_sale_state)
      : SaleState.Unknown,
    singleSaleState: single_sale_state
      ? createSaleState(single_sale_state)
      : SaleState.Unknown,
  };
}
